import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=64897cf7&scoped=true"
import script from "./infos.vue?vue&type=script&lang=js"
export * from "./infos.vue?vue&type=script&lang=js"
import style0 from "./infos.vue?vue&type=style&index=0&id=64897cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64897cf7",
  null
  
)

export default component.exports